module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px",
      "show-close": false
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [_c('h2', [_vm._v("Din reservation har gått ut")]), _vm._v(" "), _c('p', [_vm._v("Din reservation i varukorgen har gått ut. Andra gäster kan boka det som var reserverat av dig.")]), _vm._v(" "), _c('p', [_vm._v("Klicka nedan för att gå till varukorgen, där kan du prova att boka igen.")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToCart()
      }
    }
  }, [_vm._v("Okej, gå till varukorgen")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49171e32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BookingCancelled.vue
// module id = 951
// module chunks = 0